import { Box, Chip, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import type { Job } from '../../../core/types/data-models';
import { formatGenerationProgress } from './jobDisplay';

/** Inline progress panel for a generate-document job — the empty-project generator's, or a validation stage's. */
export function GenerationProgressPanel({
  job,
  title = 'Generating Product Vision…',
}: {
  job: Job | undefined;
  title?: string;
}) {
  const generationProgress = formatGenerationProgress(job?.progressAdditionalData);
  return (
    <Paper
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        p: 6,
      }}
    >
      <Stack alignItems="center" spacing={1}>
        <AutoAwesomeIcon sx={{ fontSize: 40, color: 'primary.main' }} />
        <Typography variant="h6" fontWeight={700}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {job?.progressMessage ?? 'Starting job…'}
        </Typography>
        {generationProgress && (
          <Typography variant="caption" color="text.disabled">
            {generationProgress}
          </Typography>
        )}
      </Stack>
      <Box sx={{ width: '100%', maxWidth: 480 }}>
        <LinearProgress
          variant={(job?.progressPercent ?? 0) > 0 ? 'determinate' : 'indeterminate'}
          value={job?.progressPercent ?? 0}
          sx={{ height: 8, borderRadius: 4 }}
        />
        <Stack direction="row" justifyContent="space-between" sx={{ mt: 0.75 }}>
          <Chip
            label={job?.status ?? 'PENDING'}
            size="small"
            color={job?.status === 'PROCESSING' ? 'primary' : 'default'}
          />
          <Typography variant="caption" color="text.secondary">
            {job?.progressPercent ?? 0}%
          </Typography>
        </Stack>
      </Box>
    </Paper>
  );
}
